<template>
  <v-container>
    <v-card class="mx-auto" flat>
      <v-row>
        <v-col>
          <p class="headline font-weight-bold" style="color:#AF8936; font-size: 27px !important;">
            Cambios Magistrado
          </p>
        </v-col>
      </v-row>

      <v-divider class="mb-2"></v-divider>
      <v-row>
        <v-col align="right">

          <template>
          <v-row>
            <v-col align="right">
            <v-dialog
              v-model="dialog"
              width="750"
              persistent
            >
              <v-card>
                <v-toolbar
                  dark
                  color="#AF8936"
                  dense
                >
                  <v-icon v-if="editedIndex > -1">mdi-pencil</v-icon>
                  <!-- <v-icon v-else large>mdi-folder-plus</v-icon> -->
                  <v-card-title color="#AF8936">
                    <span>{{ formTitle }}</span>
                  </v-card-title>
                  <v-spacer></v-spacer>
                  <!-- <v-btn
                    text
                    @click.native="close()"
                  >
                    <v-icon>mdi-close</v-icon>Cerrar
                  </v-btn> -->

                </v-toolbar>
                <v-container grid-list-md>
                  <v-list-item class="mt-2 mb-n7">
                    <v-list-item-content>
                      <v-list-item-title class="headline">
                        Toca Numero:
                        <span v-if="this.editedItem.derivado">
                          {{this.editedItem.numero}}-{{this.editedItem.periodo}}-{{this.editedItem.derivado}}
                        </span>
                        <span v-else>{{this.editedItem.numero}}-{{this.editedItem.periodo}}</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-container>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation><br>
                        <v-row>
                          <v-col cols="12" sm="12" class="mb-n5">
                            <v-select
                              label="Sala"
                              dense
                              outlined
                              v-model="editedItem.sala_id"
                              :items="listSalas"
                              :rules="notBlankRules"
                              prepend-icon="mdi-gavel"
                              item-text="nombre"
                              item-value="id"
                              no-data-text="No hay salas"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" class="mb-n5">
                            <v-autocomplete
                              label="Magistrado"
                              dense
                              outlined
                              v-model="editedItem.magistrado_id"
                              :items="listMagistrados"
                              item-text="ncompleto"
                              item-value="id"
                              prepend-icon="mdi-account"
                              no-data-text="No hay magistrados"
                              clearable
                              :disabled="check_magistrado"
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="6" class="mb-n5 mt-n3 mx-7">
                            <v-checkbox
                            class=""
                            color="#AF8936"
                            v-model="check_magistrado"
                            prepend-icon=""
                            label="Sin Magistrado"
                            ></v-checkbox>
                            </v-col>
                        </v-row>
                        <br>

                        <v-row>
                          <v-col cols="12">
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="red darken-1" outlined @click.native="close">Cancelar</v-btn>
                              <v-btn v-if="editedIndex > -1" color="yellow darken-2" outlined @click.native="editSentencia(editedItem)" :disabled="loading || !valid" :loading="loading">Actualizar</v-btn>
                              <!-- <v-btn v-else color="yellow darken-3" outlined @click.native="saveSentencia()" :disabled="loading || !valid" :loading="loading"> Guardar </v-btn> -->
                            </v-card-actions>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>

            </v-dialog>
            </v-col>
          </v-row>
        </template>
        </v-col>
      </v-row>

      <v-row class="mt-n7">
        <v-col>
          <p class="title" style="color:gray; font-size: 17px !important;" align="center">CONSULTA DE SENTENCIAS</p>
        </v-col>
      </v-row>

      <div class="parrafo mt-2">
        <p>Ingrese el número de toca a consultar ejemplo: <strong>23-2020</strong>, seleccione la Sala y/o Magistrado</p>
      </div>

      <v-form @submit.prevent="save" ref="search" v-model="validateToca" lazy-validation>
        <v-row class="mt-7">
          <v-col cols="12" sm="3" class="mt-n7">
            <v-text-field
              v-model.trim="number"
              label="Número de Toca"
              clearable
              @blur="clear()"
              :rules="tocaRules"
              outlined
              dense
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="5" class="mt-n7">
            <v-select
              :items="listSalas"
              v-model="sala_id"
              label="Sala"
              item-value="id"
              item-text="nombre"
              v-on:change="clear()"
              clearable
              dense
              outlined
            >
            </v-select>
          </v-col>

          <v-col cols="12" sm="4" class="mt-n7">
            <v-autocomplete
              :items="listMagistrados"
              v-model="magistrado_id"
              label="Ingrese Magistrado"
              item-value="id"
              item-text="ncompleto"
              clearable
              dense
              outlined
            >
          </v-autocomplete>
          </v-col>
        </v-row>
        </v-form>

        <v-row class="mt-n7">
          <v-spacer></v-spacer>
          <v-col cols="12" md="2">
            <v-btn
              block
              tile
              color="#616161"
              @click.native="cleanBuscar()"
              class="white--text"
              small
              >
              Nueva Búsqueda
            </v-btn>
          </v-col>

          <v-col cols="12" md="2">
            <v-btn
              block
              tile
              color="#AF8936"
              @click.native="buscar(); scroll()"
              :disabled="!validateToca"
              class="white--text"
              small
              >
              <v-icon>mdi-magnify</v-icon>
              Buscar
            </v-btn>
          </v-col>
        </v-row>

      <v-row>
        <v-col class="scroll-to-me">
          <h4 class="overline">Resultados de la consulta</h4>
        </v-col>
        <v-spacer></v-spacer>
        <!-- <v-col cols="12" md="3" class="text-right">
          <div class="flex-grow-1" style="color:#AF8936">
            <h4 v-if="roleUser == 'enlace' && this.currentUser.sala_data.id == totalSala" >Total tocas sala {{this.currentUser.sala_data.id}}: {{tocasTotal}}</h4>
            <h4 v-if="roleUser == 'admin' || roleUser == 'superadmin'">Total tocas: {{this.totalTocasAdmin}} </h4>
            <h4> Total tocas: {{this.totalTocasAdmin}} </h4>
          </div>
        </v-col> -->
      </v-row>
      <v-row>
        <v-col cols="12" md="10">
          <!-- <h4 class="overline">Al colocar el  puntero sobre los datos de las columnas se mostrará la información completa.</h4> -->
        </v-col>

        <v-col class="mt-n1" cols="12" md="2">
          <v-select
            :items="cantidad"
            v-model="paginador"
            item-text="value"
            item-value="value"
            label="Resultados por página"
            v-on:change="paginar()"
            dense
            outlined
          >
          </v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            dense
            :headers="headers"
            :items="listTocas"
            item-value="id"
            item-text="numero"
            class="elevation-1"
            :loading="loading"
            light
            actions
            :page.sync="page"
            :items-per-page="per_page_table"
            hide-default-footer
            @page-count="pageCount = $event"
            no-data-text="No se Encontraron Tocas"
            elevation="7"
          >
            <template v-slot:item.toca = "{item}">
              <td v-if="item.derivado">{{ item.numero }}-{{ item.periodo}}-{{item.derivado}}</td>
              <td v-else>{{ item.numero }}-{{ item.periodo}}</td>
            </template>
            <template v-slot:item.sala = "{item}">
              <td>SALA {{ item.salas_data.id }}</td>
            </template>
            <template v-slot:item.magistrado = "{item}">
              <td v-if="item.magistrado_data">
                {{ item.magistrado_data.nombre }} {{ item.magistrado_data.primer_apellido}} {{item.magistrado_data.segundo_apellido}}
              </td>
            </template>
            <!-- <template v-slot:item.delito = "{item}">
              <div v-if="item.delito_data">
                <v-tooltip v-if="item.delito_data.nombre.length > 15" top>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      v-bind="attrs"
                      v-on="on"
                    ><td class="truncate">{{ item.delito_data.nombre }}</td>
                  </span>
                  </template>
                  <span>{{ item.delito_data.nombre }}</span>
                </v-tooltip>
                <td class="truncate" v-else>{{ item.delito_data.nombre }}</td>
              </div>
            </template> -->

            <!-- <template v-slot:item.accion_especifica = "{item}">
              <div v-if="item.accion_especifica_data">
                <v-tooltip v-if="item.accion_especifica_data.nombre.length > 15" top>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      v-bind="attrs"
                      v-on="on"
                    ><td class="truncate">{{ item.accion_especifica_data.nombre }}</td>
                  </span>
                  </template>
                  <span>{{ item.accion_especifica_data.nombre }}</span>
                </v-tooltip>
                <td class="truncate" v-else>{{ item.accion_especifica_data.nombre }}</td>
              </div>
            </template> -->

            <!-- <template v-slot:item.accion_simultanea = "{item}">
              <div v-if="item.accion_simultanea_data">
                <v-tooltip v-if="item.accion_simultanea_data.nombre.length > 15" top>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      v-bind="attrs"
                      v-on="on"
                    ><td class="truncate">{{ item.accion_simultanea_data.nombre }}</td>
                  </span>
                  </template>
                  <span>{{ item.accion_simultanea_data.nombre }}</span>
                </v-tooltip>
                <td class="truncate" v-else>{{ item.accion_simultanea_data.nombre }}</td>
              </div>
            </template> -->


            <template v-slot:item.url = "{item}">
              <td>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mr-1"
                    x-small
                    icon
                    @click="copyURL(item)"
                  >
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-content-copy
                    </v-icon>
                  </v-btn>
                </template>

                <span>Copiar URL</span>
              </v-tooltip>
              <!-- {{ path + '/getfile/'+ item.id }} -->
              {{ item.id }}
              </td>
            </template>
            <template v-slot:item.fecha_publicacion = "{item}">
              <td class="capitalize">{{ item.fecha_publicacion | formatDate }}</td>
            </template>
            <template v-slot:item.created_at = "{item}">
              <td class="capitalize">{{item.created_at | formatDate}}</td>

            </template>
            <template v-slot:item.eliminado = "{item}">

              <td v-if="item.deleted_at == null ">-</td>
              <td v-else class="capitalize">{{item.deleted_at | formatDate}}</td>

            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                small
                color="#616161"
                icon
                dark
                @click="getFile(item)"
              >
                <v-icon>
                  mdi-download
                </v-icon>
              </v-btn>&nbsp;
              <v-btn
                v-if="(roleUser == 'superadmin' || roleUser == 'admin')  || (isLoggedIn && ( currentUser.magistrado_data.id == item.magistrado_id) &&
                ( currentUser.magistrado_data.sala_id == item.sala_id) )"
                small
                color="orange"
                icon
                dark
                @click="editItem(item)"
              >
                <v-icon>
                  mdi-pencil
                </v-icon>
              </v-btn>&nbsp;
              <!-- <v-btn
                v-if="(roleUser == 'superadmin' || roleUser == 'admin')  || (isLoggedIn && ( currentUser.magistrado_data.id == item.magistrado_id) &&
                ( currentUser.magistrado_data.sala_id == item.sala_id) )"
                small
                color="#F44336"
                icon
                dark
                @click="deleteSentencia(item)"
              >
                <v-icon>
                  mdi-delete-forever
                </v-icon>
              </v-btn> -->
            </template>
          </v-data-table>
          <div class="text-center pt-2">
            <v-pagination
              v-if="pagination.total > 1"
              v-model="pagination.current"
              :length="pagination.total"
              :total-visible="7"
              @input="onPageChange"
              color="#AF8936"
            ></v-pagination>
          </div>

        </v-col>
      </v-row>

      <v-dialog
        v-model="progress"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="grey darken-2"
          dark
        >
          <v-card-text>
            Cargando Archivo
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogCopy"
        hide-overlay
        persistent
        width="150"
      >
        <v-card
          color="green"
          dark
        >
          <v-card-text class="mb-n5">
            <b class="ml-3 font-weight-black">Url copiada</b>
          </v-card-text>
        </v-card>
      </v-dialog>

    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
const Swal = require('sweetalert2');
  export default {
    data: () => ({
      path: process.env.VUE_APP_PATH_DOWNLOAD,
      dialogCopy:false,
      searchInput:'',
      valid: true,
      validateToca: true,
      totalSala:'',
      number:'',
      sala_id:'',
      numero:'',
      derivado:'',
      periodo:'',
      magistrado_id:'',
      check_magistrado:false,
      pagination: {
        current: 1,
        total: 0
      },
      per_page_table:20,
      paginador:20,
      cantidad: [
        { id: 1, value: 10 },
        { id: 2, value: 20 },
        { id: 3, value: 30 },
        { id: 4, value: 40 },
        { id: 5, value: 50 }
      ],
      TocasList:[],
      totalTocasAdmin:'',
      dialog: false,
      progress: false,
      loading:false,
      page: 1,
      pageCount: 0,
      itemsPerPage:40,
      file:[],
      files:[],
      archivo:{
        encode:'',
      },
      tocaRules: [
        v => /^(\d+)(\-)(\d{4})(-[A-Z]*)*$/.test(v) || 'Ingrese formato valido',
      ],
      editedItem: {
        sala_id:'',
        magistrado_id:'',
        numero:'',
        periodo: new Date().getFullYear(),
        derivado:'',
        file:'',
      },
      defaultItem: {
        sala_id:'',
        magistrado_id:'',
        numero:'',
        periodo: new Date().getFullYear(),
        derivado:'',
        file:'',
      },
      editedIndex: -1,
      notBlankRules: [v => !!v || 'Este campo es requerido'],
    }),
    computed:{
      headers(){
        if (this.isLoggedIn) {
          return [
            { text: 'Toca', value: 'toca', width: "12%"},
            { text: 'Sala', value: 'sala', width: "8%"},
            { text: 'Magistrado', value: 'magistrado', width: "30%" },
            // { text: 'Materia', value: 'materia_data.nombre', width: "9%" },
            // { text: 'Delito/Acción', value: 'delito'},
            // { text: 'Acción Específica', value: 'accion_especifica'},
            // { text: 'Acción Simultánea', value: 'accion_simultanea'},
            { text: 'Url descarga', value: 'url', sortable: false, width: "10%"},
            { text: 'Fecha de Publicación', value: 'fecha_publicacion', width: "10%" },
            { text: 'Fecha de Creación', value: 'created_at', width: "10%" },
            { text: 'Fecha Eliminado', value: 'eliminado',  width: "10%" },
            { text: 'Acciones', value: 'action', sortable: false, width: "10%"}
          ]
        }
        // else {
        //   return [
        //     { text: 'Toca', value: 'toca', width: "12%" },
        //     { text: 'Sala', value: 'sala', width: "8%" },
        //     { text: 'Materia', value: 'materia_data.nombre', width: "9%" },
        //     { text: 'Delito/Acción', value: 'delito' },
        //     { text: 'Acción Específica', value: 'accion_especifica' },
        //     { text: 'Acción Simultánea', value: 'accion_simultanea' },
        //     { text: 'Fecha de Publicación', value: 'fecha_publicacion', width: "10%" },
        //     { text: 'Acciones', value: 'action', sortable: false, width: "10%" }
        //   ]
        // }
      },
      formTitle () {
        return this.editedIndex === -1 ? 'Nueva Publicación' : 'Editar Publicación'
      },
      ...mapGetters([
        "listTocas",
        "tocasTotal",
        "listSalas",
        "roleUser",
        "isLoggedIn",
        "currentUser",
        "listMagistrados",
        // "listSentidos"
      ])
    },
    watch: {
      number: function (val) {
        this.pagination.current = 1;
        if(!val){
          this.number = '',
          this.validateToca = true;
          this.buscar()
          return this.$refs.search.resetValidation()
        }
      },
      sala_id (val){
        this.pagination.current = 1;
        // this.filterMateriasPublic(val);
        if(!val){
          // this.listMateriasSearch = this.listMaterias
          this.materia_id = ''
          this.number = ''
          this.sala_id = ''
          // this.accion_especifica_id = ''
          // this.accion_simultanea_id = ''
          this.validateToca = true;
          return this.$refs.search.resetValidation()
        }
      },
      check_magistrado (val){
        if (val) {
          this.editedItem.magistrado_id = 0
        }
        if(!val){
          this.editedItem.magistrado_id = null
        }
      },
    },
    mounted(){
      this.getSalas()
      this.getMagistrados()
      this.buscar()
    },
    filters: {
      filterDate(date) {
        return date.slice(0, 10);
      },
      capitalising: function (data) {
        var capitalized = []
        data.split(' ').forEach(word => {
          capitalized.push(
            word.charAt(0).toUpperCase() +
            word.slice(1).toLowerCase()
          )
        })
        return capitalized.join(' ')
      }
    },
    methods:{
      paginar(){
        this.pagination.current = 1;
        this.buscar()
      },
      scroll(){
        const el = this.$el.getElementsByClassName('scroll-to-me')[0];
        el.scrollIntoView({ behavior: 'smooth' })
      },
      cleanBuscar () {
          this.pagination.current = 1;
          this.number = '',
          this.sala_id = '',
          this.magistrado_id = '',
          this.$refs.search.resetValidation()
          this.buscar()
          // this.validateToca = true
      },
      clear () {
        if (!this.number) {
          this.$refs.search.resetValidation()
          this.validateToca = true
        }
        // if (this.materia_id) {
        //   this.tipoJuicio()
        // }
        // this.number = ''
      },

      getSalas() {
        if (this.currentUser.id > 2) {
          this.getMaterias();
        }
        this.loading = true;
        this.$store.dispatch("GET_SALAS",  { url: "/salas" } ).then(response => {
          // console.log(response.data);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
      },
      getMagistrados() {
        this.loading = true;
        this.$store.dispatch("GET_MAGISTRADOS",  { url: "/magistrados" } ).then(response => {
          // console.log(response.data);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
      },
      getTocasCount() {
        // this.loading = true;
        this.$store.dispatch("GET_TOCAS_COUNT",  { url: "/tocas/sala/"+this.currentUser.sala_data.id+"/count" } ).then(response => {
          // console.log(response.data);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
      },
      editItem (item) {
        // console.log(item);
        this.editedIndex = this.listTocas.indexOf(item)
        // this.editedItem = Object.assign({}, item)
        this.editedItem.id = item.id
        this.editedItem.sala_id = item.sala_id
        if (item.magistrado_id > 0) {
          this.editedItem.magistrado_id = item.magistrado_id
        }
        if (item.magistrado_id == 0) {
          this.check_magistrado = true
        }
        this.editedItem.numero = item.numero
        this.editedItem.periodo = item.periodo
        this.editedItem.derivado = item.derivado
        // this.editedItem.role = item.roles[0].id
        this.dialog = true
      },
      buscar() {
        this.loading = true;
        if (this.number) {
          var number = this.number
          number = number.split("-",3)
          // console.log(number);
          this.numero = number[0];
          this.periodo = number[1];
          this.derivado = number[2];
        }  else {
          this.validateToca = true
          this.$refs.search.resetValidation()
        }
        this.$store.dispatch("GET_TOCAS", { url:  "/tocas-salas?page=" + this.pagination.current,
          data: {
            sala_id:this.sala_id,
            numero:this.numero,
            periodo:this.periodo,
            derivado:this.derivado,
            magistrado_id:this.magistrado_id,
            paginador: this.paginador
          }
          })
        .then((response) => {
          this.loading = false
          this.pagination.current = response.data.data.tocas.current_page;
          this.pagination.total = response.data.data.tocas.last_page;
          this.per_page_table = response.data.data.tocas.per_page;
          this.TocasList = response.data.data.tocas.data;
          this.numero = '';
          this.periodo = '';
          this.totalSala = this.sala_id;
          // if(this.roleUser == 'superadmin' || this.roleUser == 'admin'){
            this.totalTocasAdmin = response.data.data.tocas.total
          // }
        })
        .catch(error => {
          this.loading = false;
          this.numero = '';
          this.periodo = '';
          this.number = '';
          console.log(error);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Ingresa un numero de toca válido',
            confirmButtonText: "Aceptar"
          })
        });
        this.$refs.search.resetValidation()
      },
      onPageChange() {
        this.buscar();
      },

      getFile(item){
        this.progress = true
        this.$store
          .dispatch("GET_FILE", item.id)
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response[0].data], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = url;
            // link.setAttribute('target' ,'_blank');
            link.setAttribute('download', item.id +'.pdf');
            document.body.appendChild(link);
            link.click();
            this.progress = false
          })
          .catch(err => {
            console.log(err);
          });
      },

      editSentencia(item){
       // if (this.$refs.form.validate()) {
          if ((this.editedItem.magistrado_id == null && !this.check_magistrado) || this.editedItem.sala=="") {
            Swal.fire({
              icon: 'warning',
              title: 'Verifica la opción de Magistrado',
              showConfirmButton: false,
              timer: 2000
            })
          } else {
            this.loading = true
            // console.log(item);
            this.$store.dispatch("EDIT_TOCA", {
              url: "/toca-sala/"+item.id,
              data : item
            })
            .then((response) => {
              // console.log(response);
              if (response.data.status == 'ok') {
                  Swal.fire({
                    icon: 'success',
                    title: 'Sentencia Actualizada',
                    showConfirmButton: false,
                    timer: 1500
                  })
                this.close();
                this.progress = false
               this.buscar()
               if (this.roleUser == 'enlace') {
                 this.getTocasCount()
               }
              }
            })
            .catch(err => {
              if (err.response && err.response.status === 401) return;
              let mensaje = 'Ocurrió un error al guardar el cambio.';
              if (err.response && err.response.data && err.response.data.message) {
                mensaje = err.response.data.message;
              } else if (err.response && err.response.status === 429) {
                mensaje = 'Demasiadas solicitudes. Espere un momento e intente de nuevo.';
              }
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: mensaje,
                showConfirmButton: true,
              })
              this.progress = false
              this.loading = false
            });
          }
       // }
      },
      fileSelected(){
        var file = this.file[0];
        this.getBase64(file).then(data => {
          this.files.push(data);
        });
      },
      getBase64(file) {
        return new Promise((resolve, reject) => {
          if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
          }
        });
      },
      b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || "";
        sliceSize = sliceSize || 512;
        var byteCharacters = atob(b64Data);
        var byteArrays = [];
        for (
          var offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
      },
      FilesToUpload() {
        if (this.files.length) {
          this.files.forEach(file => {
            var block = file.split(";");
            // Get the content type of the image
            var contentType = block[0].split(":")[1]; // In this case "jpg
            // get the real base64 content of the file
            // this.archivo['type'] = contentType
            var realData = block[1].split(",")[1];
            //console.log(realData);
            this.archivo['encode'] = realData
            // this.archivo['file_name'] = this.file[0].name
          });
        }
      },
      // deleteSentencia(item){
      //   var sentencia = item.numero + '-' + item.periodo
      //   if (item.derivado) {
      //     sentencia = sentencia + '-' + item.derivado
      //   }
      //   this.$swal({
      //     title: '¿Eliminar Sentencia ' + sentencia +'?',
      //     text: '',
      //     icon: 'question',
      //     showCancelButton: true,
      //     confirmButtonText: "Aceptar"
      //   }).then((result) => {
      //     if (result.value) {
      //       this.$store.dispatch("DELETE_SENTENCIA",  { url: "/toca/" + item.id } ).then(res => {
      //         Swal.fire({
      //           icon: 'success',
      //           title: 'Sentencia eliminada correctamente.',
      //           confirmButtonText: "Aceptar"
      //         })
      //         this.buscar()
      //         if(this.roleUser == 'enlace'){
      //           this.getTocasCount()
      //         }
      //       })
      //       .catch(err => {
      //         console.log(err);
      //       });
      //     }
      //   })
      // },
      close () {
        this.$refs.form.resetValidation()
        this.editedItem = Object.assign({}, this.defaultItem)
        this.check_magistrado = false
        this.editedIndex = -1
        this.dialog = false
        this.file = []
      },
      copyURL(item) {
        this.dialogCopy = true
        const el = document.createElement('textarea');
        el.value = 'https://publicacionsentencias.stjjalisco.gob.mx/getfile/' + item.id;
        el.setAttribute('readonly', '');
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        var that = this;
        setTimeout(function () {
          that.dialogCopy = false
        }, 800);
      }
    }

  }
</script>

<style scoped>
  .parrafo {
    color: #000000;
    font-size: 15px;
    text-align: justify;
    font-family: inherit;
    font-weight: normal;
    line-height: 1.6;
    margin-bottom: 17px;
  }
  .truncate {
    max-width: 130px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .select-text {
    font-size: 13px;
    font-weight: 500;
  }
  .text-genero /deep/ label {
    color: purple;
    font-weight: bold;
  }
  .text-ninez /deep/ label {
    color: #2096F3;
    font-weight: bold;
  }
  .capitalize {
  text-transform: capitalize;
 }
</style>
